import React from "react";
import AdminCard from "./adminCard";
import "./pending.css";

const Pending = ({ ordersFound, data, handleStatusClick, handleDeliveryClick, handleChef, handleComment, handleRefund }) => {
  const handleOrder = (orderID) => {
    window.open(`/order?orderID=${orderID}`, "_blank");
  };

  return (
    <div className="pending">
      {ordersFound ? (
        data.map((data, id) => (
          <AdminCard
            id={id}
            data={data}
            handleOrder={handleOrder}
            status="PENDING"
            handleChef={handleChef}
            handleStatusClick={handleStatusClick}
            handleDeliveryClick={handleDeliveryClick}
            handleComment={handleComment}
            handleRefund={handleRefund}
          />
        ))
      ) : (
        <h1>No Pending Orders</h1>
      )}
    </div>
  );
};

export default Pending;
